@if (requisition) {
  <rt-box
    variant="no-padding no-radius no-border"
    layout
    layout-align-items-center
    layout-space-between
    border-bottom
  >
    <div layout-vertical>
      <rt-requisitions-header
        [title]="requisition.title"
        [isEditable]="isTitleEditable"
        [guid]="requisition.guid"
        [status]="requisition.status"
        [titleSaved$]="titleSaved$"
        [isArchived]="isArchived"
        [approvalRequest]="approvalRequestWithRequester"
        (saveTitle)="updateTitle($event)"
        padding-left-medium
      />
      <rt-requisitions-tabs
        [offersCount]="requisition.offersCount"
        [hiresCount]="requisition.hiresCount"
        [openingsCount]="requisition.openingsCount"
        [attachmentsCount]="requisition.attachmentsCount"
        [notesCount]="requisition.notesCount"
        margin-top-small-xx
      />
    </div>
    <div layout>
      <rt-admins-avatars
        [admins]="assignedAdmins"
        [editable]="canEditMembers"
        [limit]="4"
        [stacked]="true"
        (addClick)="editTeamMembers()"
        (avatarsClick)="editTeamMembers()"
      />
      <rt-follow-button
        [type]="'requisition'"
        [followed]="requisition.followed"
        [loading]="false"
        (followClick)="followClick()"
        (unfollowClick)="followClick()"
        margin-lr-small
      />
    </div>
  </rt-box>
}
